import React from 'react';
import PropTypes from 'prop-types';
import style from '@src/js/Style';

export default class Label extends React.Component {

    static get propTypes() {

        return {
            children: PropTypes.any,
            className: PropTypes.string,
        };
    }

    render() {

        const classes = [style('title4 text-medium')];
        
        if (this.props.className != undefined)
            classes.push(this.props.className);

        return this.props.children
            ? <label className={ classes.join(' ') }>{ this.props.children }</label>
            : null;
    }

}